import { DestroyRef, signal } from '@angular/core';

/**
 * Creates a reactive signal that tracks a media query match.
 * Automatically cleans up the listener when the component is destroyed.
 *
 * Usage (inside a component/service with inject context):
 *   private readonly isMobile = mediaSignal('(max-width: 640px)', this.destroyRef);
 */
export function mediaSignal(query: string, destroyRef: DestroyRef) {
  const mql = window.matchMedia(query);
  const matches = signal(mql.matches);
  const handler = (e: MediaQueryListEvent) => matches.set(e.matches);
  mql.addEventListener('change', handler);
  destroyRef.onDestroy(() => mql.removeEventListener('change', handler));
  return matches.asReadonly();
}
